module.exports = __webpack_public_path__ + "img/typeall.b66fc110.png";